<template>
  <div class="tags">
    <tag-icon
      :isTagsActive="sidebar.opened"
      @toggleClick="toggleSideBar"
    ></tag-icon>
    <ul>
      <li
        class="tags-li"
        v-for="(item, index) in tagsList"
        :class="{ active: isActive(item.name) }"
        :key="index"
      >
        <span class="tags-choose"></span>
        <router-link :to="item.path" class="tags-li-title">
          {{ item.title }}
        </router-link>
        <span
          class="tags-li-icon"
          v-if="item.path !== '/dashboard' && item.path !== '/404'"
          @click="closeTags(index)"
          ><i class="el-icon-close "></i
        ></span>
      </li>
    </ul>
  </div>
</template>

<script>
import bus from './bus'
import { mapGetters } from 'vuex'
import tagIcon from './Tagsicon'
export default {
  data() {
    return {
      tagsList: [],
      curItem: [],
      newRoute: {},
      newRouteItem: {}
    }
  },
  components: {
    tagIcon
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },

    isActive(name) {
      return name === this.$route.name
    },
    // 关闭单个标签
    closeTags(index) {
      const delItem = this.tagsList.splice(index, 1)[0]
      const item = this.tagsList[index]
        ? this.tagsList[index]
        : this.tagsList[index - 1]
      if (item) {
        delItem.path === this.$route.fullPath && this.$router.push(item.path)
      } else {
        this.$router.push('/')
      }
    },
    closeOther() {
      const curItem = this.tagsList.filter(item => {
        return item.name == this.newRoute.name
      })
      this.tagsList = curItem
    },
    closeAll() {
      this.tagsList = []
      this.$router.push('/')
    },
    // 关闭当前标签
    closeTag(name) {
      const chooseItem = this.tagsList.filter(item => {
        return item.name !== name
      })
      this.tagsList = chooseItem
      if (this.tagsList.length == 0) {
        this.$router.push('/dashboard')
      }
    },

    // 设置标签
    setTags(route) {
      const isExist = this.tagsList.some(item => {
        return item.path === route.fullPath
      })
      if (!isExist) {
        if (this.tagsList.length >= 5) {
          this.tagsList.shift()
        }
        this.tagsList.push({
          title: route.meta.title || '主页',
          path: route.fullPath,
          name: route.name || route.matched[1].components.default.name
        })
      }
    }
  },
  computed: {
    ...mapGetters(['sidebar'])
  },
  watch: {
    $route(newValue, oldValue) {
      this.newRoute = newValue
      this.setTags(newValue)
    }
  },
  mounted() {
    
    bus.$on('closeOthers', () => {
      this.tagsList = []
    })
    this.tagsList = []
    this.$router.push('/')
    
      ///console.log("orgType================================="+this.$store.state.user.userInfo.org.orgType)
      if( this.$store.state.user.userInfo.org.orgType == '87'  ){
          this.$router.push({ name: 'applyindex'})
      }else{
           this.tagsList.push({
              title: '主页',
              path: '/dashboard',
              name: 'Dashboard'
            })
      }  
  },
  created() {
    bus.$on('closeTag', name => {
      this.closeTag(name)
    })
   
    this.setTags(this.$route)
  }
}
</script>

<style lang="scss">
.hamburger {
  display: inline-block;
  vertical-align: middle;
}

.hamburger.is-active {
  transform: rotate(180deg);
}
.tags {
  // position: relative;
  position: fixed;
  top: 95px;
  height: 35px;
  z-index: 20;
  width: 100%;
  overflow: hidden;
  background: transparent;
  padding-right: 120px;
  background: #ffffff;
  /* box-shadow: 0 5px 10px #ddd; */
}

.tags ul {
  box-sizing: border-box;
  margin: 0;
  padding-left: 32px;
  background: transparent;
  width: 100%;
  height: 24px;
}

.tags-li {
  float: left;
  position: relative;
  margin: 5px 5px 0px 3px;
  border-radius: 3px;
  font-size: 12px;
  overflow: hidden;
  cursor: pointer;
  height: 24px;
  /* width: 99px; */
  line-height: 24px;
  border: 1px solid #e9eaec;
  background: #e9ebee;
  padding: 0 5px 0 14px;
  vertical-align: middle;
  color: #939393;
  -webkit-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
}

.tags-li:not(.active):hover {
  background: #f8f8f8;
}
.tags-li-title {
  float: left;
  // max-width: 80px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 8px;
  color: #666;
}
.tags-li.active {
  background: #026dc6;
  color: #ffffff;
}
.tags-li.active .tags-li-title {
  // background: #026DC6;
  color: #ffffff;
}
.tags-li.active ::after {
  background: #ffffff;
  content: '';
  width: 5px;
  height: 5px;
  position: absolute;
  border-radius: 50%;
  top: 37%;
  left: 4px;
}

.tags-li-icon {
  float: left;
}
.tags-close-box {
  position: absolute;
  right: 15px;
  top: 2px;
  box-sizing: border-box;
  padding-top: 1px;
  text-align: center;
  width: 110px;
  height: 30px;
  background: transparent;
  z-index: 10;
}
.tags-btn {
  background-color: #fff;
  border-radius: 0;
}
// .el-button{
// border-radius:0;
// }
.el-dropdown-menu {
  padding: 2px 0;
}

.el-dropdown-menu__item {
  margin: 2px 0;
  line-height: 27px;
}
.el-dropdown-menu__item--divided {
  position: relative;
  margin-top: 0px;
  border-top: 1px solid #ebeef5;
}
.el-dropdown-menu__item--divided:before {
  content: '';
  height: 2px;
  display: block;
  margin: 0 -20px;
  background-color: #fff;
}
</style>
